import { render, staticRenderFns } from "./DeliverableDetail.vue?vue&type=template&id=85245bd4&scoped=true&"
import script from "./DeliverableDetail.vue?vue&type=script&lang=js&"
export * from "./DeliverableDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeliverableDetail.vue?vue&type=style&index=0&id=85245bd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85245bd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VMenu,VSelect,VTab,VTabs,VTextarea})
